export const colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF',
  },
  black: {
    base: '#141823',
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)',
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED',
  },


  grey: {
    grey15: '#dcddde',
    grey50: '#898b91',
    grey75: '#4f525a',
    lightGrey: '#c9d4e1',
    lineGrey: '#eff3f8',
    bgGrey: '#e9eff5',
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2',
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA',
  },
  blue: {
    bgBlue: '#eef4fd',
    deepBlue: '#1951b5',
    lightBlue: '#d1e5ff',
    bgBlueLight: '#accff9',
    bgBlueLightHome: '#6da4ea',
    bgSegmentDark: '#1149f3',
    bgSegmentLight: '#00c3ff',
    blueBorder: '#e5edf6',
  },
  red: {
    base: '#ff3a5c',
    lightRed: '#ffebee',
    bgRed: '#feebf0',
    pinkRed: '#ff8a9e',
    bgLightRed: '#ffe7e5',
    ratingRed: '#9b041e',
  },
  green: {
    base: '#2bac36',
    lightGreen: '#e9f6ea',
    bgGreen: '#7ccf51',
    bgGreenDark: '#18a160',
    darkBushGreen: '#11998e',
    cGreen: '#dafac9',
    cGreenDark: '#63c033',
    ratingGreen: '#5fa735',
    bgDarkGreen: '#039556',
    darkGreen: '#005d2f',
    cGreenNew: '#7cd051',
    taGreen: '#00b087',
  },
  yellow: {
    base: '#fdba00',
    lightYellow: '#fef8e5',
    bgYellow: '#fff5da',
    darkerYellow: '#fdaf15',
    lightCream: '#fdf3d9',
    cYellow: '#f39c12',
    borderYellow: '#fee6a0',
    ratingYellow: '#f59d00',
  },
  white: {
    base: '#ffffff',
  },
  brown: {
    darkBrown: '#614919',
    warmBrown: '#854700f7',
  },
  purple: {
    base: '#861388',
    lightPurple: '#f2e7f3',
  },
  cyan: {
    base: '#1aabb8',
  },
  amber: {
    base: '#8e5a14',
  },
  goBrand: {
    blue: '#2276e3',
    orange: '#ff6d38',
    goStays: '#ff7d22',
  },
  orange: {
    bgOrange: '#fcbe5b',
    lightOrange: '#ffe3b7',
    base: '#eda93c',
    ratingOrange: '#ed6112',
  },
  pink: {
    base: '#fff0eb',
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)',
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA',
  }
};

export function buildColors() {
  // return {
  //   black: {
  //     base: '#141823',
  //   },
  //   grey: {
  //     grey15: '#dcddde',
  //     grey50: '#898b91',
  //     grey75: '#4f525a',
  //     lightGrey: '#c9d4e1',
  //     lineGrey: '#eff3f8',
  //     bgGrey: '#e9eff5',
  //   },
  //   blue: {
  //     bgBlue: '#eef4fd',
  //     deepBlue: '#1951b5',
  //     lightBlue: '#d1e5ff',
  //     bgBlueLight: '#accff9',
  //     bgBlueLightHome: '#6da4ea',
  //     bgSegmentDark: '#1149f3',
  //     bgSegmentLight: '#00c3ff',
  //     blueBorder: '#e5edf6',
  //   },
  //   red: {
  //     base: '#ff3a5c',
  //     lightRed: '#ffebee',
  //     bgRed: '#feebf0',
  //     bgLightRed: '#ffe7e5'
  //   },
  //   green: {
  //     base: '#2bac36',
  //     lightGreen: '#e9f6ea',
  //     bgGreen: '#7ccf51',
  //     bgGreenDark: '#18a160',
  //     darkBushGreen: '#11998e',
  //     cGreen: '#dafac9',
  //     cGreenDark: '#63c033'
  //   },
  //   yellow: {
  //     base: '#fdba00',
  //     lightYellow: '#fef8e5',
  //     bgYellow: '#fff5da',
  //     darkerYellow: '#fdaf15',
  //   },
  //   white: {
  //     base: '#ffffff',
  //   },
  //   purple: {
  //     base: '#861388',
  //     lightPurple: '#f2e7f3',
  //   },
  //   cyan: {
  //     base: '#1aabb8',
  //   },
  //   amber: {
  //     base: '#8e5a14',
  //   },
  //   goBrand: {
  //     blue: '#2276e3',
  //     orange: '#ff6d38',
  //   },
  //   orange: {
  //     bgOrange: '#fcbe5b',
  //     lightOrange: '#ffe3b7',
  //     base: '#eda93c'
  //   },
  //   pink: {
  //     base: '#fff0eb',
  //   },
  //   shadow: {
  //     light: 'rgba(0, 0, 0, 0.13)',
  //     base: 'rgba(0,0,0,0.25)',
  //     dark: 'rgba(0,0,0,0.5)',
  //   },
  // };
  return colorPalette;
}

// export const black = {
//   base: '#141823',
// };
// export const grey = {
//   grey15: '#dcddde',
//   grey50: '#898b91',
//   //   grey75: '#4f525a',
//   //   lightGrey: '#c9d4e1',
//   //   lineGrey: '#eff3f8',
// };
// export const blue = {
//   bgBlue: '#eef4fd',
//   deepBlue: '#1951b5',
//   lightBlue: '#d1e5ff',
//   bgBlueLight: '#accff9',
// };
// export const red = {
//   base: '#ff3a5c',
//   lightRed: '#ffebee',
//   bgRed: '#feebf0',
// };
// export const green = {
//   base: '#2bac36',
//   lightGreen: '#e9f6ea',
//   bgGreenDark: '#18a160',
// };
// export const yellow = {
//   base: '#fdba00',
//   lightYellow: '#fef8e5',
//   bgYellow: '#fff5da',
//   darkerYellow: '#fdaf15',
// };
// export const white = {
//   base: '#ffffff',
// };
// export const purple = {
//   base: '#861388',
//   lightPurple: '#f2e7f3',
// };
// export const cyan = {
//   base: '#1aabb8',
// };
// export const goBrand = {
//   blue: '#2276e3',
//   orange: '#ff6d38',
// };
